import { fetchBaseQuery } from '@reduxjs/toolkit/query';
import { ASSISTANT_SMM_API_URL } from '@skynet/config-provider';
import { prepareAuthHeaders } from '@skynet/data-auth-api';

/**
 * Base query for the Assistant SMM (social media management) API.
 */
export const assistantSmmApiBaseQuery = fetchBaseQuery({
  baseUrl: ASSISTANT_SMM_API_URL,
  prepareHeaders: prepareAuthHeaders,
});
